import { useMutation, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { LoginNextResponse, SessionTenant } from "@/types/auth";

/**
 * The tenants a super admin belongs to, for the user menu's tenant switch
 * (AB#8687). Fetched only while that view is open.
 */
export function useSessionTenants(enabled: boolean) {
  return useQuery({
    queryKey: ["admin", "session", "tenants"],
    queryFn: () => api.get<SessionTenant[]>("/api/admin/session/tenants"),
    enabled,
  });
}

/**
 * Moves the session to another tenant the super admin belongs to, then
 * full-reloads to the next URL the server returns, so the session, its
 * feature flags and every cached query start over in the new tenant.
 */
export function useSwitchTenant() {
  return useMutation({
    mutationFn: (tenantId: string) =>
      api.post<LoginNextResponse>("/api/admin/session/switch", {
        tenant_id: tenantId,
      }),
    onSuccess: (response) => {
      window.location.assign(response.next);
    },
  });
}
